/**
 * Org free-form label catalog (Configure / Insights filters + LabelEditor
 * autocomplete). Distinct from the SCADA `tags` registry.
 */

import { createApi } from '@reduxjs/toolkit/query/react'

import { PROXY_API_V1_URL, ontologyBaseQuery } from '../core'
import type { ResourceLabelCatalogEntry, ResourceLabelCatalogPage } from './types'

export const RESOURCE_LABEL_TAG_TYPES = ['ResourceLabel'] as const

function asArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : []
}

export const resourceLabelsApi = createApi({
  reducerPath: 'resourceLabelsApi',
  baseQuery: ontologyBaseQuery,
  tagTypes: [...RESOURCE_LABEL_TAG_TYPES],
  endpoints: (builder) => ({
    listResourceLabels: builder.query<
      ResourceLabelCatalogEntry[],
      { q?: string; pageSize?: number } | void
    >({
      query: (args) => {
        const params = new URLSearchParams()
        if (args?.q) params.set('q', args.q)
        if (args?.pageSize) params.set('page_size', String(args.pageSize))
        const qs = params.toString()
        return `${PROXY_API_V1_URL}/resource-labels${qs ? `?${qs}` : ''}`
      },
      transformResponse: (response: ResourceLabelCatalogPage) =>
        asArray<ResourceLabelCatalogEntry>(response?.labels),
      providesTags: [{ type: 'ResourceLabel', id: 'LIST' }]
    })
  })
})

export const { useListResourceLabelsQuery } = resourceLabelsApi
